import { Omit, Partial } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { CurrencyConversion } from './currency-conversion.entity';
import { CurrencyConversionProviderType } from './currency-conversion.provider-type.enum';
import { CurrencyConversionStatus } from './currency-conversion.status.enum';

export class CreateCurrencyConversionDto extends Partial(
    Omit(CurrencyConversion, [...BaseEntityFieldsArray, 'status', 'provider'], ['status', 'provider']),
) {
    status?: CurrencyConversionStatus;
    provider?: CurrencyConversionProviderType;
}
